import {Parse} from "parse";
import {isIOS} from "./deviceInfo";
import {dispatch} from "../../index";
import * as actions from "../store/actions";
import {getDaysLeft} from "../screens/main/main-menu";
import { getErrorMessage } from '@lib/errorMessage';

const isValidPaidDate = (paidDate) => {
    if (!!paidDate) {
        const daysLeft = getDaysLeft(paidDate);
        // console.warn('daysLeft:', daysLeft);
        return daysLeft > 0;
    }
    return false;
};

export const getTrial = async ({uid, email, displayName}, setNotiTitle) => {
    // console.log('getTrial!');
    const Client = Parse.Object.extend('Client');
    const query = new Parse.Query(Client);
    query.equalTo('uid', uid);
    //query.limit(25);
    try {
        const obj = await query.first();
        console.log('object->', obj);
        if (!obj) {
            const client = new Client();
            client.set('uid', uid);
            client.set('trial', true);
            client.set('email', email);
            client.set('displayName', displayName);
            await client.save();

            dispatch(actions.addUserData({isTrial: true}));
        } else {
            const isTrial = obj.get('trial');
            const paidDate = obj.get('paidDate') || '';
            const isValid = isValidPaidDate(paidDate);
            //TODO костыль для ios - полный доступ
            dispatch(actions.addUserData({
                paidDate: paidDate,
                isTrial: !isValid,
            }));
            !isValid && !isIOS && obj.save({trial: true});
        }
    } catch (e) {
        console.log('error get obj:', e.message);
        const errMessage = getErrorMessage(e);
        //setTimeout(() => setNotiTitle(errMessage), 6000);
    }
    //console.log('object->', object);
};
